import { RecaptchaComponent } from './recaptcha.component';
import { RecaptchaPopupComponent } from './recaptcha-popup.component';

const CAPTCHA = [RecaptchaPopupComponent, RecaptchaComponent];

export {
  RecaptchaPopupComponent,
  RecaptchaComponent,
  CAPTCHA
};



// WEBPACK FOOTER //
// ./src/app/captcha/components/index.ts